import { render } from "./Feature.vue?vue&type=template&id=3bc640bd&scoped=true"
import script from "./Feature.vue?vue&type=script&lang=js"
export * from "./Feature.vue?vue&type=script&lang=js"

import "./Feature.vue?vue&type=style&index=0&id=3bc640bd&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc640bd"]])

export default __exports__